import { jsx as _jsx } from "nativewind/jsx-runtime";
import { ScreenLayout } from '@/components/ScreenLayout';
import React from 'react';
import CrusherActivitySeasonView from '../CrusherActivity/views/CrusherActivitySeasonView';
export default function PastSeasonDetailScreen({ route, }) {
    const { crusherClubId, title } = route.params;
    return (_jsx(ScreenLayout, { isHeaderVisible: true, children: _jsx(CrusherActivitySeasonView, { crusherClubId: crusherClubId, title: title }) }));
}
